<template>
  <div class="player-detail-container">
    <el-tabs v-model="activeName" type="card" >
      <el-tab-pane label="基本信息" name="first">
        <el-form v-if="player" class="user-from" label-width="140px" >
          <el-form-item class="label-line-height" label="上传头像" >
            <el-upload
              :on-success="handleSuccess"
              :on-error="handleError"
              :before-upload="beforeAvatarUpload"
              :show-file-list="false"
              :data="dataObj"
              :action="qiniuUp"
              :accept="accept"
              class="upload-size"
              list-type="picture-card">
              <el-popover
                placement="top-start"
                trigger="hover">
                <div class="popover-content"><img :src="player.profile | ImageFormats" alt="img"></div>
                <img v-show="player.profile" slot="reference" :src="player.profile | ImageFormats" >
              </el-popover>
              <i v-show="!player.profile" class="el-icon-plus avatar-uploader-icon"/>
              <div slot="tip" class="el-upload__tip">会员审核只支持上传标准证件照，建议不超过5Mb</div>
            </el-upload>
          </el-form-item>
          <el-form-item label="用户姓名">
            <el-input v-model="player.trueName" />
          </el-form-item>
          <el-form-item label="性别" >
            <el-radio v-model="player.gender" label="男">男</el-radio>
            <el-radio v-model="player.gender" label="女">女</el-radio>
          </el-form-item>
          <el-form-item label="国籍">
            <el-select v-model="player.nationality" filterable placeholder="请选择国籍">
              <el-option label="中国" value="中国"/>
              <el-option label="其他" value="其他"/>
            </el-select>
          </el-form-item>
          <el-form-item label="出生日期" >
            <el-date-picker
              v-model="player.birthday"
              type="date"
              placeholder="选择日期时间"/>
          </el-form-item>
          <el-form-item label="证件类型">
            <el-select v-model="player.certificateType" filterable placeholder="身份证" @change="confirmCertificateType">
              <el-option v-for="item in certificateType" :key="item.id" :label="item.name" :value="item.id"/>
            </el-select>
          </el-form-item>
          <el-form-item label="证件号码">
            <el-input v-model="player.certificateNum" />
          </el-form-item>
          <el-form-item label="证件正面">
            <el-upload
              :show-file-list="false"
              :data="dataObj"
              :action="qiniuUp"
              :accept="accept"
              :on-success="handleCertificateFront"
              :on-error="handleError"
              :before-upload="beforeAvatarUpload"
              class="upload-demo">
              <el-popover
                placement="top-start"
                trigger="hover">
                <div class="popover-content"><img :src="player.certificateFrontImg | ImageCertFormats" alt="img"></div>
                <img v-show="player.certificateFrontImg" slot="reference" :src="player.certificateFrontImg | ImageFormats" class="certificate-upload-style" >
              </el-popover>
              <div v-show="!player.certificateFrontImg" class="certificate-upload-style" >
                选择上传文件
              </div>
              <div slot="tip" class="el-upload__tip">注：请上传运动员身份证正反面照片，并底衬A4纸附监护人/本人（16岁以上）签名</div>
            </el-upload>
          </el-form-item>
          <el-form-item label="证件反面">
            <el-upload
              :show-file-list="false"
              :data="dataObj"
              :action="qiniuUp"
              :accept="accept"
              :on-success="handleCertificateBack"
              :on-error="handleError"
              :before-upload="beforeAvatarUpload"
              class="upload-demo">
              <el-popover
                placement="top-start"
                trigger="hover">
                <div class="popover-content"><img :src="player.certificateBackImg | ImageCertFormats" alt="img"></div>
                <img v-show="player.certificateBackImg" slot="reference" :src="player.certificateBackImg | ImageFormats" class="certificate-upload-style" >
              </el-popover>
              <div v-show="!player.certificateBackImg" class="certificate-upload-style" >
                选择上传文件
              </div>
              <div slot="tip" class="el-upload__tip">注：请上传运动员身份证正反面照片，并底衬A4纸附监护人/本人（16岁以上）签名</div>
            </el-upload>
          </el-form-item>
          <el-form-item label="身高(CM)">
            <el-input v-model="player.high" />
          </el-form-item>
          <el-form-item label="体重(KG)">
            <el-input v-model="player.weight" />
          </el-form-item>
          <el-form-item label="持杆方式" >
            <el-radio v-model="player.stickHand" label="左手杆">左手杆</el-radio>
            <el-radio v-model="player.stickHand" label="右手杆">右手杆</el-radio>
          </el-form-item>
          <el-form-item label="学生类型" >
            <el-radio v-model="player.category" label="北京学生">北京学生</el-radio>
            <el-radio v-model="player.category" label="外地学生">外地学生</el-radio>
            <el-radio v-model="player.category" label="学龄前儿童">学龄前儿童</el-radio>
            <el-radio v-model="player.category" label="成人">成人</el-radio>
          </el-form-item>
          <el-form-item v-show="player.category == '北京学生'" label="就读学校">
            <el-select v-model="player.schoolId" filterable placeholder="请选择学校" style="width: 300px">
              <el-option v-for="item in school" :key="item.id" :label="item.name" :value="item.id" />
            </el-select>
          </el-form-item>
          <el-form-item v-show="player.category == '北京学生'" label="学籍卡">
            <el-upload
              :show-file-list="false"
              :data="dataObj"
              :action="qiniuUp"
              :accept="accept"
              :on-success="handlestudentCardImg"
              :on-error="handleError"
              :before-upload="beforeAvatarUpload"
              class="upload-demo">
              <el-popover
                placement="top-start"
                trigger="hover">
                <div class="popover-content"><img :src="player.studentCardImg | ImageCertFormats" alt="img"></div>
                <img v-show="player.studentCardImg" slot="reference" :src="player.studentCardImg | ImageFormats" class="certificate-upload-style" >
              </el-popover>
              <div v-show="!player.studentCardImg" class="certificate-upload-style" >
                选择上传文件
              </div>
              <div slot="tip" class="el-upload__tip">注：北京学生需要提交学籍卡信息（或者北京通，新生可以上传录取通知书）</div>
            </el-upload>
          </el-form-item>
          <el-form-item label="入学年度" >
            <el-date-picker
              v-model="player.enterSchoolYear"
              type="year"
              placeholder="选择日期时间"
              @blur="confirmTime('enterSchoolYear')"/>
          </el-form-item>
          <el-form-item label="教育背景">
            <el-input
              :rows="2"
              v-model="player.educationSummary"
              type="textarea"
              placeholder="请输入教育背景简介"/>
          </el-form-item>
          <el-form-item label="再次注册年度" >
            <el-input v-model="player.membershipYear" disabled />
            <el-dropdown trigger="click" placement="bottom">
              <span class="el-dropdown-link font-size-style">
                历史注册年度<i class="el-icon-arrow-down el-icon--right"/>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-for="item in historyYears" :key="item.year">{{ item.year }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </el-form-item>
          <el-form-item label="注册地">
            <el-select v-model="player.area" filterable placeholder="请选择" style="width: 300px">
              <el-option v-for="(item, index) in areaList" :key="index" :label="item" :value="item" />
            </el-select>
          </el-form-item>
          <el-form-item label="请选择渠道">
            <el-select v-model="player.source" filterable placeholder="请选择" style="width: 300px">
              <el-option v-for="(item, index) in sourceList" :key="index" :label="item" :value="item" />
            </el-select>
          </el-form-item>
          <el-form-item v-if="player.source==sourceList[3]" label="请填写其他渠道">
            <el-input
              :rows="2"
              v-model="player.otherSource"
              type="textarea"
              placeholder="请输入"/>
          </el-form-item>
          <el-form-item>
            <el-button v-permission="['user-player-edit']" :loading="userLoding" type="primary" @click="setUserManage()" >保存</el-button>
            <!--<el-button type="info" plain>返回</el-button>-->
          </el-form-item>
        </el-form>

      </el-tab-pane>
      <el-tab-pane label="冰球水平" name="second">
        <el-form v-if="player" label-width="96px" class="lce-hockey-level" >
          <el-form-item label="现所属会员单位/公司" >
            <el-select v-model="player.organizationId" filterable placeholder="会员单位" style="width: 300px">
              <el-option v-for="item in organizationList" :key="item.id" :label="item.name" :value="item.id" />
            </el-select>
            <el-dropdown trigger="click" placement="bottom">
              <span class="el-dropdown-link font-size-style">
                历史会员单位<i class="el-icon-arrow-down el-icon--right"/>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-for="item in historyOrgs" :key="item.id">{{ item.name }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </el-form-item>
          <el-form-item label="所属冰球队">
            <el-input v-model="player.team" />
          </el-form-item>
          <el-form-item label="场上位置" >
            <el-radio v-model="player.position" label="前锋">前锋</el-radio>
            <el-radio v-model="player.position" label="后卫">后卫</el-radio>
            <el-radio v-model="player.position" label="守门员">守门员</el-radio>
          </el-form-item>
          <el-form-item label="队服号码">
            <el-input v-model="player.jerseyNo" type="number" />
          </el-form-item>
          <el-form-item label="现任教练">
            <el-select v-model="player.coachId" filterable placeholder="选择教练">
              <el-option v-for="item in coachList" :key="item.id" :label="item.trueName" :value="item.id"/>
            </el-select>
          </el-form-item>
          <el-form-item label="曾经球队">
            <el-input
              v-model="player.declaredHistoryTeams"
              placeholder="多个球队以', '分隔"/>
          </el-form-item>
          <el-form-item label="之前所属会员单位">
            <el-input v-model="player.declaredHistoryOrgnizations" placeholder="多个单位以', '分隔" />
          </el-form-item>
          <el-form-item label="冰球成绩" >
            <el-input
              v-model="player.athletePerformance"
              type="textarea"
              rows="2"
              placeholder="请输入冰球成绩"/>
          </el-form-item>
          <el-form-item>
            <el-button v-permission="['user-player-edit']" :loading="userLoding" type="primary" @click="setUserManage()" >保存</el-button>
            <!--<el-button type="info" plain>返回</el-button>-->
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <el-tab-pane label="联系方式" name="third">
        <el-form label-width="96px" class="hockey-contact" >
          <el-form-item label="电子邮箱" >
            <el-input v-model="player.email" />
          </el-form-item>

          <div v-for="(item, index) in guardians" :key="index" class="guardians" >
            <el-form-item label="监护人">
              <el-input v-model="item.name" />
            </el-form-item>
            <el-form-item label="证件类型">
              <el-select v-model="item.certificateType" filterable placeholder="身份证" @change="confirmCertificateType">
                <el-option v-for="item in certificateType" :key="item.id" :label="item.name" :value="item.id"/>
              </el-select>
            </el-form-item>
            <el-form-item label="证件号码">
              <el-input v-model="item.certificateNum" />
            </el-form-item>
            <el-form-item label="联系电话">
              <el-input v-model="item.mobile" />
            </el-form-item>
            <el-form-item v-show="false" label="行业">
              <el-input v-model="item.work" />
            </el-form-item>
            <el-form-item label="工作地址">
              <el-input v-model="item.address" />
            </el-form-item>
            <el-form-item label="与队员关系">
              <el-input v-model="item.relation" />
            </el-form-item>
          </div>
          <el-form-item>
            <el-button v-permission="['user-player-edit']" :loading="userLoding" type="primary" @click="updateGguardian()" >保存</el-button>
            <!--<el-button type="info" plain>返回</el-button>-->
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <el-tab-pane label="北京青少年队入选经历" name="forth">
        <div class="add">
          <el-select v-model="year" style="width: 120px; margin-right: 10px;" placeholder="请选择年度">
            <el-option
              v-for="item in yearOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"/>
          </el-select>

          <el-select v-model="teamId" style="width: 200px; margin-right: 10px" placeholder="请选择球队">
            <el-option
              v-for="item in teamList"
              :key="item.value"
              :label="item.label"
              :value="item.value"/>
          </el-select>

          <el-button type="primary" @click="addPlayerExperience">添 加</el-button>
        </div>
        <div class="table">
          <el-table
            :data="list"
            border
            style="width: 600px; margin-top: 20px">
            <el-table-column
              prop="year"
              label="年度"
              width="120"/>
            <el-table-column
              prop="name"
              label="队名"/>
            <el-table-column
              label="操作"
              width="120">
              <template slot-scope="{row}">
                <el-link type="danger" @click="deleteExperience(row)">删 除</el-link>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import moment from 'moment'
import permission from '@/directive/permission/index.js' // 权限判断指令
import { varConfig, showMessage, ImageFormat, ConstConfig, getDateObjectByString } from '@/utils'
import { getQiniuUploadToken, getSchoolList, getSourceList } from '@/api/site'

import { getPlayerById, updatePlayer, updatePlayerGuardian } from '@/api/player'
import { getHistoryMembershipYear, getHistoryOrganization, getOrganizationList, getCoachList } from '@/api/user'
import { addPlayerTeamExperience, getPlayerTeamExperienceList, getPlayerTeamList, deletePlayerTeamExperience } from '@/api/user'

const certificateType = ConstConfig.certificateType

export default {
  name: 'Details',
  directives: { permission },
  filters: {
    ImageFormats(img) {
      return ImageFormat.squareImageView(img, 156, 2)
    },
    ImageCertFormats(img) {
      return ImageFormat.imageView(img, 960, 594, 2)
    }
  },
  data() {
    return {
      activeName: 'first',
      organizationList: {},
      dataObj: { token: '' },
      qiniuUp: varConfig.qiniuUp,
      accept: ConstConfig.accept,
      playerId: '',
      player: {},
      historyYears: [],
      historyOrgs: [],
      school: [],
      certificateType: certificateType,
      userLoding: false,
      coachList: '',
      guardians: [],
      sourceList: [],
      areaList: ['北京-长期', '非北京'],
      yearOptions: [],
      year: '',
      teamId: '',
      teamList: [],
      list: []
    }
  },
  watch: {
    'player.source': {
      handler: (val, oldVal) => { // 普通的watch监听
      }
    },
    year() {
      this.teamId = ''
      this.getPlayerTeamList()
    }
  },
  created() {
    this.playerId = this.$route.params.id
    // this.getPlayerInfo()
    this.getQiniuToken()
    this.getSchool()
    this.getOrganization()
    this.getCoachList()
    this.sourceList = getSourceList()
    this.year = new Date().getFullYear()
    for (let i = 0; i < 5; i++) {
      this.yearOptions.push({ value: this.year - i, label: this.year - i })
    }
  },
  mounted() {
    this.getPlayerTeamList()
    this.getPlayerTeamExperienceList()
  },
  methods: {
    deleteExperience(row) {
      const params = {
        playerId: this.playerId,
        teamId: row.teamId,
        year: row.year
      }
      this.$confirm('是否确认删除该经历?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deletePlayerTeamExperience(params).then(res => {
          if (res) {
            this.$message.success('删除成功')
            this.getPlayerTeamExperienceList()
          }
        })
      })
    },
    getPlayerTeamExperienceList() {
      const params = {
        playerId: this.playerId
      }
      getPlayerTeamExperienceList(params).then(res => {
        if (res) {
          this.list = res.data.list
          console.log(res.data.list)
        }
      })
    },
    addPlayerExperience() {
      if (!this.year && !this.teamId) {
        this.$message.error('请选择年度已经球队')
      }
      const params = {
        playerId: this.playerId,
        year: this.year,
        teamId: this.teamId
      }
      addPlayerTeamExperience(params).then(res => {
        if (res) {
          this.$message.success('添加成功')
          this.getPlayerTeamExperienceList()
        }
      })
    },
    getPlayerTeamList() {
      const params = {
        year: this.year,
        playerId: this.playerId
      }
      getPlayerTeamList(params).then(res => {
        if (res) {
          const list = res.data.list
          this.teamList = []
          list.forEach(item => {
            this.teamList.push({ value: item.id, label: item.name })
          })
        }
      })
    },
    getSchool() {
      getSchoolList().then((resolve) => {
        this.school = resolve.data.list
      }, (reject) => {
      })
    },
    getPlayerInfo() {
      getPlayerById(this.playerId).then((resolve) => {
        const player = resolve.data.player
        if (player.source) {
          if (!this.sourceList.includes(player.source)) {
            player.otherSource = player.source
            player.source = this.sourceList[3]
          }
        }
        this.player = player
        this.player.birthday = getDateObjectByString(this.player.birthday)
        if (this.player.organizationId) {
          var self = this
          var organization = _.find(this.organizationList, function(item) {
            return item.id == self.player.organizationId
          })
          this.player.organizationId = organization ? organization.id : ''
        }
        this.guardians = this.player.guardians
        if (this.guardians && this.guardians.length < 2) {
          this.guardians.push({ name: '', address: '', mobile: '', email: '', relation: '' })
        } else {
          //          this.guardians = this.guardians.reverse()
        }
        this.getHistoryMembershipYear(this.player.userId)
        this.getHistoryOrganization(this.player.userId)
      }, (reject) => {
      })
    },
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 10
      if (!isLt2M) {
        showMessage('error', '上传头像图片大小不能超过 10MB!')
      }
      return isLt2M
    },
    handleSuccess(response) {
      this.$set(this.player, 'profile', response.hash)
    },
    handleCertificateFront(response) {
      this.player.certificateFrontImg = response.hash
    },
    handleCertificateBack(response) {
      this.player.certificateBackImg = response.hash
    },
    handlestudentCardImg(response) {
      this.player.studentCardImg = response.hash
    },
    getQiniuToken() {
      getQiniuUploadToken().then(response => {
        const data = response.data
        this.dataObj.token = data.token
      }).catch(err => {
        console.log(err, 'error', '七牛Token获取失败')
      })
    },
    handleError(file) {

    },
    setUserManage() {
      // ///
      const params = {
        id: this.playerId,
        profile: this.player.profile,
        trueName: this.player.trueName,
        gender: this.player.gender,
        nationality: this.player.nationality,
        birthday: this.player.birthday ? moment(this.player.birthday).format('YYYY-MM-DDTHH:mm:ss+0800') : '',
        certificateType: this.player.certificateType,
        certificateNum: this.player.certificateNum,
        certificateFrontImg: this.player.certificateFrontImg,
        certificateBackImg: this.player.certificateBackImg,
        category: this.player.category,
        schoolId: this.player.schoolId,
        enterSchoolYear: this.player.enterSchoolYear,
        organizationId: this.player.organizationId,
        studentCardImg: this.player.studentCardImg,
        area: this.player.area,
        high: this.player.high,
        weight: this.player.weight,
        email: this.player.email,
        stickHand: this.player.stickHand,
        educationSummary: this.player.educationSummary,
        team: this.player.team,
        position: this.player.position,
        jerseyNo: this.player.jerseyNo,
        coachId: this.player.coachId,
        declaredHistoryOrgnizations: this.player.declaredHistoryOrgnizations,
        declaredHistoryTeams: this.player.declaredHistoryTeams,
        athletePerformance: this.player.athletePerformance
      }
      if (this.player.source === this.sourceList[3]) {
        params.source = this.player.otherSource
      } else {
        params.source = this.player.source
      }
      // ///
      this.userLoding = true
      updatePlayer(params).then((resolve) => {
        if (resolve) {
          this.$message({
            message: '更新成功',
            type: 'success'
          })
        }
        this.userLoding = false
      }, (reject) => {
        this.userLoding = false
        this.$message.error('数据保存失败')
      })
    },
    getHistoryMembershipYear(userId) {
      getHistoryMembershipYear(userId, 1).then(response => {
        const data = response.data
        const list = data.list
        const newList = this.getNewYearsList(list)
        this.historyYears = newList
      }).catch(err => {
      })
    },
    getNewYearsList(list) {
      const playerName = this.player.trueName
      const yearList = {
        '舒骏宇': [{ year: '2017' }, { year: '2016' }],
        '李迦南': [{ year: '2015' }, { year: '2014' }],
        '丁一': [{ year: '2017' }, { year: '2016' }, { year: '2015' }, { year: '2014' }, { year: '2013' }],
        '耿若茗': [{ year: '2017' }, { year: '2016' }, { year: '2015' }, { year: '2014' }, { year: '2013' }],
        '李以衡': [{ year: '2017' }, { year: '2016' }, { year: '2015' }, { year: '2014' }, { year: '2013' }],
        '魏圣玺': [{ year: '2017' }, { year: '2016' }, { year: '2015' }, { year: '2014' }],
        '陈沐晗': [{ year: '2017' }, { year: '2016' }, { year: '2015' }, { year: '2014' }, { year: '2013' }],
        '刘一然': [{ year: '2017' }, { year: '2016' }, { year: '2015' }, { year: '2014' }, { year: '2013' }],
        '董云龙': [{ year: '2017' }, { year: '2016' }, { year: '2015' }, { year: '2014' }, { year: '2013' }],
        '王振博': [{ year: '2017' }, { year: '2016' }, { year: '2015' }, { year: '2014' }, { year: '2013' }],
        '张睿轩': [{ year: '2016' }, { year: '2015' }, { year: '2014' }, { year: '2013' }],
        '张宜赫': [{ year: '2017' }, { year: '2016' }, { year: '2015' }, { year: '2014' }],
        '马博宣': [{ year: '2017' }, { year: '2016' }, { year: '2015' }, { year: '2014' }, { year: '2013' }],
        '王奥': [{ year: '2017' }, { year: '2016' }, { year: '2015' }, { year: '2014' }],
        '田林泽': [{ year: '2017' }, { year: '2016' }, { year: '2015' }, { year: '2014' }],
        '陆畅': [{ year: '2017' }, { year: '2016' }, { year: '2015' }, { year: '2014' }, { year: '2013' }],
        '黄少琰': [{ year: '2017' }, { year: '2016' }, { year: '2015' }, { year: '2014' }, { year: '2013' }],
        '吴禹桐': [{ year: '2016' }, { year: '2015' }, { year: '2014' }, { year: '2013' }]
      }
      const otherList = yearList[playerName] || []
      const newList = list.concat(otherList)
      return newList
    },
    getHistoryOrganization(userId) {
      getHistoryOrganization(userId, 1).then(response => {
        const data = response.data
        this.historyOrgs = data.list
      }).catch(err => {
      })
    },
    confirmTime(field) {
      this.player[field] = moment(this.player[field]).format('YYYY')
    },
    confirmCertificateType(val) {
    },
    getOrganization() {
      getOrganizationList().then((resolve) => {
        this.organizationList = resolve.data.list
        this.getPlayerInfo()
      }, (reject) => {})
    },
    getCoachList() {
      getCoachList().then((resolve) => {
        this.coachList = resolve.data.list
      }, (reject) => {})
    },
    updateGguardian() {
      const param = {
        playerId: this.playerId,
        guardians: JSON.stringify(this.guardians)
      }
      updatePlayerGuardian(param).then((resolve) => {
        if (resolve) {
          this.$message({
            message: '更新成功',
            type: 'success'
          })
        } else {
          this.$message.error('数据保存失败')
        }
      })
      this.setUserManage()
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss">
  .player-detail-container {
    margin: 30px 15px;
    .action-header {
      padding: 0 10px 10px 10px;
    }
    .el-table {
      th {
        div {
          line-height: 20px;
        }
        .el-select {
          padding-left: 0;
          padding-right: 0;
          .el-input {
            padding-left: 0;
            padding-right: 0;
          }
        }
      }
    }

    .table-footer {
      text-align: center;
      margin-top: 30px;
    }

    .upload-size .el-upload {
      width: 80px;
      height: 80px;
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }

    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 78px;
      height: 78px;
      line-height: 78px !important;
      text-align: center;
      position: absolute;
      top: 0;
      left: 0;
    }

    .upload-size .el-upload:hover {
      border-color: #409EFF;
    }

    .upload-size .el-upload-list li {
      width: 80px;
      height: 80px;
    }

    .label-line-height .el-form-item__label {
      line-height: 80px;
      text-align: center;
    }

    /*.user-from, .lce-hockey-level, .hockey-contact {*/
      /*width: 800px;*/
    /*}*/

    .user-from .el-form-item__label {
      text-align: left;
      padding-left: 15px;
    }

    .certificate-upload-style {
      width: 120px;
      height: 32px;
      border: 1px solid #dcdfe6;
      border-radius: 4px;
      color: #999999;
      line-height: 32px;
    }

    .font-size-style {
      font-size: 14px;
      color: #169BD5;
      padding-left: 20px;
    }

    .team-info-width {
      width: auto;
      margin-right: 12px;
    }

    .el-upload img {
      width: 78px;
      height: 78px;
    }

    .guardians {
      border-bottom: 1px solid #ccc;
      margin-bottom:17px;
      width: 600px;
    }

    .guardians:nth-child(2) {
      border-bottom: none;
    }

    .el-input--small {
      max-width: 300px;
    }

    .el-dropdown {
      cursor: pointer;
    }

  }

  .el-popover .popover-content img {
    max-width: 360px;
  }
</style>
